import { ToastOptions, ToastParams, ToastPayload } from "types/toast";
import { create } from "zustand";

type ToastStoreState = {
  toasts: ToastPayload[];
  add: (payload: ToastParams) => string;
  remove: (id: string) => void;
};

const defaultToastOptions: ToastOptions = {
    duration: 2000,
    position: 'top',
    type: 'default',
};

const generateUniqueId = (): string => {
    return crypto.randomUUID();
};

const useToastStore = create<ToastStoreState>((set, get) => ({
  toasts: [],
  add: (payload: ToastParams): string => {
    const id = generateUniqueId();
    const toast: ToastPayload = { ...payload, id, options: { ...defaultToastOptions, ...payload.options } };

    const currentToasts = get().toasts;

    // 이전 토스트가 있으면 이전 토스트 제거
    if (currentToasts.length >= 1) {
      const firstToast = currentToasts[0];
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== firstToast.id) }));
      setTimeout(() => {
        set((state) => ({ toasts: [...state.toasts, toast] }));
      }, 200);
    } else {
      set((state) => ({ toasts: [...state.toasts, toast] }));
    }
    return id;
  },
  remove: (id: string) => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
}));

export default useToastStore;